export default __webpack_public_path__ + "static/media/69t.0f0e56ab.jpg";